import React, { FC, useCallback, useEffect, useState } from "react";
import DialogWizardContext from "./DialogWizardContext";

export type WizardStepProps = {
  onNextStep?: VoidFunction;
  onPreviousStep?: VoidFunction;
};

const { Provider } = DialogWizardContext;

export type DialogWizardProps = {
  steps: FC<WizardStepProps>[];
  currentStep?: number;
};

const DialogWizard: FC<DialogWizardProps> = ({ steps = [], currentStep }) => {
  const [step, setStep] = useState(currentStep || 0);
  const Step = steps[step];
  const onNextWizardStep = useCallback(async () => {
    if (step + 1 !== steps.length) {
      setStep(currentWizardStep => currentWizardStep + 1);
    }
  }, [step, steps.length]);
  const onPreviousWizardStep = useCallback(async () => {
    setStep(currentWizardStep => currentWizardStep - 1);
  }, []);

  useEffect(() => {
    if (currentStep !== void 0) {
      setStep(currentStep);
    }
  }, [currentStep]);

  return (
    <Provider
      value={{
        step,
        stepsCount: steps.length,
        onNextStep: onNextWizardStep,
        onPreviousStep: onPreviousWizardStep,
      }}
    >
      <Step onNextStep={onNextWizardStep} onPreviousStep={onPreviousWizardStep} />
    </Provider>
  );
};

export default DialogWizard;
